import { AuthConfig } from '@aws-amplify/core';
import { fetchAuthSession, signInWithRedirect } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import {
  getQueryParamByKey,
  getStringFromLocalStorage,
  hasValue,
  setSessionStorageItem,
  stringToBoolean,
} from '@r-and-a-shared-ui/utils';
import {
  AmplifyAuthEvents,
  AuthConstants,
  OauthQuery,
} from './constants/auth-constants';
import { handleUncaughtFlow, isOauthSignInFlow } from './auth-helpers';

const AMPLIFY_OAUTH_STORE_PREFIX = 'CognitoIdentityServiceProvider';
const AMPLIFY_OAUTH_INFLIGHT_KEY = 'inflightOAuth';

const getAmplifyOauthStorageKey = (config: AuthConfig, key: string) => {
  const clientId = config?.Cognito?.userPoolClientId;

  if (!hasValue(clientId)) {
    return undefined;
  }

  return `${AMPLIFY_OAUTH_STORE_PREFIX}.${clientId}.${key}`;
};

export const isStaleOauthCallback = (config: AuthConfig) => {
  const code = getQueryParamByKey(OauthQuery.CODE);

  if (!hasValue(code)) {
    return false;
  }

  const storageKey = getAmplifyOauthStorageKey(
    config,
    AMPLIFY_OAUTH_INFLIGHT_KEY,
  );

  if (!hasValue(storageKey)) {
    return false;
  }

  const inflight = getStringFromLocalStorage(storageKey as string);

  return !stringToBoolean(inflight);
};

let isRecovering = false;

export const recoverStaleOauthCallback = async () => {
  if (isRecovering) {
    return;
  }

  isRecovering = true;

  const session = await fetchAuthSession({ forceRefresh: true }).catch(
    () => undefined,
  );

  if (hasValue(session?.tokens)) {
    Hub.dispatch('auth', { event: AmplifyAuthEvents.SignedIn });
    return;
  }

  if (!isOauthSignInFlow()) {
    setSessionStorageItem(
      AuthConstants.OauthSignInReturnUrl,
      encodeURIComponent(window.location.origin),
    );
  }

  try {
    await signInWithRedirect();
  } catch (error) {
    console.error('Error restarting the oauth flow:', error);
    handleUncaughtFlow();
  }
};
